module.exports = __webpack_public_path__ + "static/gestion_tierras_main-4b8c9158689a33d766e0a707dea3afcc.png";